"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_NOTIFICATION: function() {
        return ADD_NOTIFICATION;
    },
    DELETE_NOTIFICATION: function() {
        return DELETE_NOTIFICATION;
    },
    DUPLICATE_NOTIFICATION: function() {
        return DUPLICATE_NOTIFICATION;
    },
    GENERATE_NOTIFICATIONS: function() {
        return GENERATE_NOTIFICATIONS;
    },
    RESET_NOTIFICATIONS: function() {
        return RESET_NOTIFICATIONS;
    },
    UPDATE_NOTIFICATION: function() {
        return UPDATE_NOTIFICATION;
    }
});
const ADD_NOTIFICATION = "ADD_NOTIFICATION";
const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
const GENERATE_NOTIFICATIONS = "GENERATE_NOTIFICATIONS";
const RESET_NOTIFICATIONS = "RESET_NOTIFICATIONS";
const DUPLICATE_NOTIFICATION = "DUPLICATE_NOTIFICATION";
